import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './SubscriptionExpiredModal.css'; // NUEVO archivo CSS responsive
import { useSubscription } from '../context/SubscriptionContext';

const SubscriptionExpiredModal = () => {
  const { isExpired, loading } = useSubscription();
  const navigate = useNavigate();
  const location = useLocation();

  const isRenewalPath = location.pathname.startsWith('/subscription')
    || location.pathname.startsWith('/checkout');

  if (loading || !isExpired || isRenewalPath) return null;

  return (
    <div className="subscription-modal-backdrop">
      <div className="subscription-modal">
        <h2>Suscripción Vencida</h2>
        <p>Tu suscripción ha vencido. Renovála para seguir usando The Thing App.</p>
        <p>No podrás realizar ninguna acción hasta que renueves tu suscripción.</p>
        <button
          className="auth-button"
          onClick={() => navigate('/subscription')}
        >
          Renovar Suscripción
        </button>
      </div>
    </div>
  );
};

export default SubscriptionExpiredModal;
